import React from 'react';
import { ClipboardCheck, Settings, Zap } from 'lucide-react';
const steps = [{
  number: '01',
  icon: ClipboardCheck,
  title: 'Review Your Systems and Processes',
  description: "We review your CAD, ERP, existing engineering change order processes, and bill of material management tracking (including PLM systems). If you have no processes, we'll help define your workflow."
}, {
  number: '02',
  icon: Settings,
  title: 'Map Your Data',
  description: 'Configure which CAD attributes sync to which ERP fields. Smart defaults get you started, then customize as needed to match your specific workflow requirements.'
}, {
  number: '03',
  icon: Zap,
  title: 'Automate Forever',
  description: 'Set it and forget it. Real-time updates happen when pushed from your CAD to your ERP so you can order your parts and track costs in real time. Zero manual work required.'
}];
export function HowItWorks() {
  return <section className="py-24 px-6 bg-slate-50" data-id="element-105">
      <div className="max-w-7xl mx-auto" data-id="element-106">
        <div className="text-center mb-16" data-id="element-107">
          <h2 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-108">
            How it works
          </h2>
          <p className="text-xl text-slate-600" data-id="element-109">
            Quick to implement with our proven process
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12" data-id="element-110">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <div key={index} className="relative" data-id="element-111">
                {/* Connector line */}
                {index < steps.length - 1 && <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-slate-200" data-id="element-112" />}

                <div className="relative bg-white rounded-xl p-8 border border-slate-200" data-id="element-113">
                  <div className="text-5xl font-bold text-blue-100 mb-4" data-id="element-114">
                    {step.number}
                  </div>
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4" data-id="element-115">
                    <Icon className="w-6 h-6 text-blue-600" data-id="element-116" />
                  </div>
                  <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-117">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed" data-id="element-118">
                    {step.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}